import { LitElement, css, html } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import moment from 'moment';
import nls from '../../locales/index.nls';
import queryParam from '@giswebgroup/ki-wcp-base/src/decorators/queryParam';

// TODO need review
/**
 * For special Accordion configurable menu mix with content. detail WH-373
 */
export default
@i18n(nls)
class KiStationMenu extends LitElement {
  static styles = css`
    :host {
      overflow: auto;
      display: block;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      transition: height linear 0s 0s, all ease-in-out 0.6s 0.1s;
    }

    .menu {
      color: grey;
      display: flex;
      padding: 0 15px;
      line-height: 30px;
    }

    .label-wrapper {
      flex: 1;
      line-height: 40px;
    }
    .label-wrapper:hover {
      cursor: pointer;
      color: var(--theme-color, #0056a0);
    }
    .expand-icon {
      line-height: 30px;
      padding: 5px 10px;
    }
    .expand-icon:hover {
      color: var(--theme-color, #0056a0);
      cursor: pointer;
    }

    .sub-menu {
      color: grey;
      line-height: 40px;
    }
    .sub-menu.hidden {
      display: none;
      height: 0;
    }
    .sub-menu.general-info {
      padding: 0 10px;
    }
    .sub-menu ki-list-item {
      padding: 0 20px;
    }
    .sub-menu ki-list-item:hover {
      cursor: pointer;
    }
    ki-list-item ki-icon {
      margin: 0 5px;
    }
    .row {
      display: table-row;
      line-height: 32px;
    }
    .cell {
      display: table-cell;
      color: #4a4a49;
    }
    .cell.label {
      min-width: 190px;
      color: gray;
      padding: 0 20px;
    }
  `;

  @queryParam('topic')
  topic;

  static get properties() {
    return {
      items: { type: Array },
      station: { type: Object }, // special general station info
      floods: { type: Object }, // major flood
      value: { type: Object }, // for single selection

      __stationReport: { type: Object },
      __annualReport: { type: Object },
      __stationImg: { type: Object },
    };
  }

  constructor() {
    super();
    this.items = [];
    this.station = {};
    this.floods = {data:[]};
    this.value = null;
    this.numFormatter = new Intl.NumberFormat(this.i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.valFormatter = new Intl.NumberFormat(this.i18n.language, { minimumFractionDigits: 5 }); // langitude, latitude
    this.__stationReport = { component: 'ki-station-report' };
    this.__annualReport = { component: 'ki-annual-report' };
    this.__stationImg = { component: 'ki-station-img' };
  }

  set items(val){
    const oldVal = this.__items;
    this.__items = val;
    this._resetListItem();
    this.requestUpdate('items', oldVal);
  }

  get items(){
    return this.__items;
  }
  
  render() {
    return html` ${this.items && this.items.map(menu => this._renderMenu(menu))} ${this.station && this._renderGeneral()} ${this.floods && this._renderMajorFloods()}
    ${this.station && this._renderDocuments()}`;
  }

  _renderMenu(menu) {
    return html`
      <div class="menu" @click="${this.toggleList}">
        <div class="label-wrapper">
          ${menu.icon ? html`<ki-icon class="label-icon" icon="${menu.icon}"></ki-icon>` : ''}
          <span class="label">${menu.label}</span>
        </div>
        <ki-icon class="expand-icon" icon="ki ${menu.expand ? 'ki-chevron-up' : 'ki-chevron-down'}"></ki-icon>
      </div>
      <ki-list class="sub-menu ${menu.expand ? '' : 'hidden'}"> ${menu.children.map(s => this._renderMenuItem(s))} </ki-list>
    `;
  }

  _renderMenuItem(list) {
    return html`
      <ki-list-item .value="${list.value}"  @click="${this.handleClick}">
        <ki-icon icon="${list.icon}"></ki-icon>
        <span>${list.label}</span>
      </ki-list-item>
    `;
  }

  _renderGeneral() {
    if (this.detailsConfig.hideGeneral) {
      return '';
    }
    let dataprovider = this.station.ADMINISTRATEUR;
    if(this.station.site_no ==="DGH"){
      dataprovider = " SPW - MI"
    }else if(this.station.site_no ==="DCENN"){
      dataprovider = " SPW - ARNE"
    }
    return html`
      <div class="menu" @click="${this.toggleList}">
        <div class="label-wrapper">
          <span class="label">${this.i18n.t('generalInfo')}</span>
        </div>
        <ki-icon class="expand-icon" icon="ki ki-chevron-down"></ki-icon>
      </div>
      <div class="sub-menu general-info hidden">
        <div class="row">
          <div class="cell label">${this.i18n.t('station_name')}</div>
          <div class="cell">${this.station.station_name || '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('station_no')}</div>
          <div class="cell">${this.station.station_no || '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('river_name')}</div>
          <div class="cell">${this.station.river_name || '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('catchment_name')}</div>
          <div class="cell">${this.station.BASSIN_GESTION_WEB || '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('station_longitude')}</div>
          <div class="cell">${this.station.station_longitude ? this.valFormatter.format(this.station.station_longitude) : '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('station_latitude')}</div>
          <div class="cell">${this.station.station_latitude ? this.valFormatter.format(this.station.station_latitude) : '-'}</div>
        </div>
        <div class="row">
          <div class="cell label">${this.i18n.t('data_provider')}</div>
          <div class="cell">${dataprovider || '-'}</div>
        </div>
      </div>
    `;
  }

  _renderMajorFloods() {
    return html`
      <div class="menu" @click="${this.toggleList}">
        <div class="label-wrapper">
          <span class="label">${this.i18n.t('majorFlood')}</span>
        </div>
        <ki-icon class="expand-icon" icon="ki ki-chevron-down"></ki-icon>
      </div>
      <div class="sub-menu general-info hidden">
        ${this.floods.data.map(flood => {
          return html`
            <div class="row">
              <div class="cell label">${moment(flood[0]).format('L')}</div>
              <div class="cell" style="text-align: right;">${flood[1] ? this.numFormatter.format(flood[1]): '-'}</div>
              <div class="cell" style="padding-left: 5px;">${this.floods.ts_unitsymbol || ''}</div>
            </div>
          `;
        })}
      </div>
    `;
  }

  _renderDocuments() {
    // TODO dont show menu point if no reports are available
    const reports = this.detailsConfig.reports || [];
    if (reports.length === 0 && this.station.image.length === 0) {
      return html``;
    }
    return html`
      <div class="menu" @click="${this.toggleList}">
        <div class="label-wrapper">
          <span class="label">${this.i18n.t('documents')}</span>
        </div>
        <ki-icon class="expand-icon" icon="ki ki-chevron-up"></ki-icon>
      </div>
      <ki-list class="sub-menu">
        ${this.station.image && this.station.image.map(s => {
          const stationImage = { ...this.__stationImg, value: s.file };
          return html` <ki-list-item .value=${stationImage} @click="${this.handleClick}">
            <ki-icon icon="ki ki-file-image-o"></ki-icon>
            <span>${s.file && s.file.slice(s.file.lastIndexOf('/') + 1)}</span>
          </ki-list-item>`;
        })}
        ${this.detailsConfig.reports.map(s => {
          return html` <ki-list-item .value=${s.name} .component=${s.component} @click="${this.handleClick}">
            <ki-icon icon=${s.icon}></ki-icon>
            <span>${this.i18n.t(s.name)}</span>
          </ki-list-item>`;
        })}
      </ki-list>
    `;
  }

  toggleList(event) {
    const subMenu = event.currentTarget.nextElementSibling; // sibling sub-menu
    const expandIcon = event.currentTarget.querySelector('.expand-icon');
    expandIcon.icon = expandIcon.icon === 'ki ki-chevron-down' ? 'ki ki-chevron-up' : 'ki ki-chevron-down';
    subMenu.classList.toggle('hidden');
  }

  handleClick(event) {
    if (!this.value || this.value !== event.currentTarget.value) {
      this.value = event.currentTarget.value;
    } else if (this.value === event.currentTarget.value) {
      this.value = null; // deselect..
    }


    this._resetListItem();

    this.dispatchEvent(
      new CustomEvent('itemSelected', {
        detail: { value: this.value, component: event.currentTarget.component},
        bubbles: true,
        composed: true,
      }),
    );
  }

  reset() {
    this._resetListItem();
  }

  _resetListItem() {
    const items = this.renderRoot.querySelectorAll('ki-list-item');
    items.forEach(item => {
      item.classList.toggle('selected', item.value === this.value);
    });
  }
}

customElements.define('ki-station-menu', KiStationMenu);
